import { SearchForm } from "@vitalsource/vstui";
import { connect } from "react-redux";
import React from "react";
import { t } from "../../../../core/translate";
import {
  actions as routerActions,
  selectors as routerSelectors
} from "../../../../../redux/router";
import { styledMedia } from "../../../../components/mediaquery/breakpoints";
import styled from "styled-components";

const Styled = {
  SearchForm: styled(SearchForm)`
    width: 870px;

    ${styledMedia.medium`
     width: 675px;
   `}

    ${styledMedia.small`
      width: 268px;
    `}
  `
};

class ExploreSearch extends React.Component {
  constructor(props) {
    super(props);
    this.searchSubmitted = this.searchSubmitted.bind(this);
  }

  searchSubmitted(e) {
    e.preventDefault();
    if (this.input.value) {
      const encodedTerm = encodeURIComponent(this.input.value);

      this.props.push("search", {
        q: encodedTerm,
        redirectOnClose: this.props.currentRoute.hash.slice(1)
      });
    }
  }

  render() {
    return (
      <Styled.SearchForm
        formProps={{
          onSubmit: this.searchSubmitted
        }}
        nativeFormControlRef={el => (this.input = el)}
        placeholder={t("base.search", "Search")}
        fullWidth
      />
    );
  }
}

const mapStateToProps = state => ({
  currentRoute: routerSelectors.getCurrentRoute(state)
});

const mapDispatchToProps = dispatch => ({
  push: (dest, params) => dispatch(routerActions.push(dest, params))
});

export default connect(mapStateToProps, mapDispatchToProps)(ExploreSearch);
